import { TableContainer } from "@/components/table-container";
import { useTranslation } from "react-i18next";
import { RenderbusTag } from "@/components/renderbus-tag";
import { BlockTabs } from "@/components";
import { RenderBilling } from "./render-billing";
import { DesktopBilling } from "./desktop-billing";
import { useGlobalStore } from "@/store/GlobalStore";

export function Billing() {
  const { t } = useTranslation("center");
  const { userInfo } = useGlobalStore();
  return (
    <TableContainer>
      <RenderbusTag>{t("consumption_warning_overview")}</RenderbusTag>
      <BlockTabs
        items={[
          {
            label: t("tab_render") || "",
            children: <RenderBilling />,
          },
          {
            label: t("tab_desktop") || "",
            hidden: !userInfo?.enableRemoteDesktop,
            children: <DesktopBilling />,
          },
        ]}
      />
    </TableContainer>
  );
}
